var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgApWaterMistSystemIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "b"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "a",
    clipPath: "url(#b)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-5 -6)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.2,31.8h0a8.43,8.43,0,0,0-8.4-8,8.239,8.239,0,0,0-5.52,2.08,6.67,6.67,0,0,0-2.48-.48A6.84,6.84,0,0,0,11,31.88a4.793,4.793,0,0,0,.8,9.52H34.2a4.8,4.8,0,1,0,0-9.6Zm0,8H11.8a3.2,3.2,0,1,1,.04-6.4.814.814,0,0,0,.6-.24.66.66,0,0,0,.2-.6V32.2a5.19,5.19,0,0,1,5.2-5.2,5.012,5.012,0,0,1,2.28.52.789.789,0,0,0,.92-.16,6.788,6.788,0,0,1,11.6,4.8v.32a1.078,1.078,0,0,0,.2.6.814.814,0,0,0,.6.24h.76a3.209,3.209,0,0,1,3.2,3.2A3.279,3.279,0,0,1,34.2,39.8ZM37.8,8.6H32.04A2.383,2.383,0,0,0,29.8,7H16.2a2.383,2.383,0,0,0-2.24,1.6H8.2a3.2,3.2,0,1,0,0,6.4h5.76a2.383,2.383,0,0,0,2.24,1.6h1.2V19a2.407,2.407,0,0,0,2.4,2.4h6.4A2.407,2.407,0,0,0,28.6,19V16.6h1.2A2.383,2.383,0,0,0,32.04,15H37.8a3.2,3.2,0,0,0,0-6.4ZM6.6,11.8a1.6,1.6,0,0,1,1.6-1.6h5.6v3.2H8.2A1.6,1.6,0,0,1,6.6,11.8ZM19,19V16.6h3.2v3.2H19.8A.8.8,0,0,1,19,19Zm8,0a.8.8,0,0,1-.8.8H23.8V16.6H27Zm2.8-4H16.2a.8.8,0,0,1-.8-.8V9.4a.8.8,0,0,1,.8-.8H29.8a.8.8,0,0,1,.8.8v4.8A.8.8,0,0,1,29.8,15Zm8-1.6H32.2V10.2h5.6a1.6,1.6,0,0,1,0,3.2Z",
    transform: "translate(0)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApWaterMistSystemIcon);
export default __webpack_public_path__ + "static/media/ap-water-mist-system-icon.239ee223fed8edecc20890cb38d36cdb.svg";
export { ForwardRef as ReactComponent };